@if (externalProviders.length > 0) {
  <div class="mb-4">
    <div class="d-grid gap-2">
      @for (provider of externalProviders; track provider.name) {
        <button
          type="button"
          class="btn btn-primary w-100"
          [disabled]="isLoading()"
          (click)="onExternalLogin(provider.name)">
          @if (provider.name === 'Microsoft') {
            <i class="bi bi-microsoft me-2"></i>
          }
          Continue with {{ provider.displayName }}
        </button>
      }
    </div>
    <div class="or-divider-container mt-3">
      <span class="text-muted">OR</span>
    </div>
  </div>
}

@if (unconfirmedEmail) {
  <div class="alert alert-warning" role="alert">
    <h6 class="alert-heading">
      <i class="bi bi-envelope-exclamation me-2"></i>
      Email address not confirmed
    </h6>
    <p class="mb-2">
      @if (confirmationEmailSent()) {
        A new confirmation email has been sent to
        <strong>{{ unconfirmedEmail }}</strong>
        . Please check your inbox and click the confirmation link.
      } @else {
        You need to confirm your email address before you can log in. Please check your inbox for a confirmation email
        sent to
        <strong>{{ unconfirmedEmail }}</strong>
        .
      }
    </p>
    @if (confirmationEmailSent()) {
      <button type="button" class="btn btn-sm btn-success" disabled>
        <i class="bi bi-check-circle-fill me-1"></i>
        Confirmation email sent
      </button>
    } @else {
      <button
        type="button"
        class="btn btn-sm btn-warning"
        [disabled]="isResendingConfirmation()"
        (click)="resendConfirmationEmail()">
        @if (isResendingConfirmation()) {
          <span class="spinner-border spinner-border-sm me-1"></span>
          Sending...
        } @else {
          <i class="bi bi-envelope me-1"></i>
          Resend confirmation email
        }
      </button>
    }
  </div>
}

<form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
  <!-- Server validation errors summary -->
  @if (serverErrors.length > 0) {
    <div class="alert alert-danger" role="alert">
      <ul class="mb-0">
        @for (error of serverErrors; track error) {
          <li>{{ error }}</li>
        }
      </ul>
    </div>
  }

  <div class="mb-3">
    <label for="loginEmail" class="form-label">Email</label>
    <input
      type="email"
      class="form-control"
      id="loginEmail"
      formControlName="email"
      [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched" />
    @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
      <div class="invalid-feedback">Please enter a valid email address</div>
    }
  </div>

  <div class="mb-3">
    <label for="loginPassword" class="form-label">Password</label>
    <input
      type="password"
      class="form-control"
      id="loginPassword"
      formControlName="password"
      [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched" />
    @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
      <div class="invalid-feedback">Password is required</div>
    }
  </div>

  <div class="mb-3 form-check">
    <input type="checkbox" class="form-check-input" id="rememberMe" formControlName="rememberMe" />
    <label class="form-check-label" for="rememberMe">Remember me</label>
  </div>

  <div class="d-grid gap-2">
    <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid || isLoading()">
      @if (isLoading()) {
        <span class="spinner-border spinner-border-sm me-2"></span>
      }
      Log In
    </button>
  </div>
</form>

@if (showRegisterLink || showForgotPasswordLink) {
  <div class="text-center mt-4">
    @if (showRegisterLink) {
      <p class="mb-2">
        Don't have an account?
        <a href="#" (click)="switchToRegister(); $event.preventDefault()" class="text-decoration-none">Sign up here</a>
      </p>
    }
    @if (showForgotPasswordLink) {
      <p class="mb-0">
        <a href="#" (click)="openForgotPassword(); $event.preventDefault()" class="text-decoration-none">
          Forgot your password?
        </a>
      </p>
    }
  </div>
}
